<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	//Design system components
	import { Button, Slider, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id),
		min = 0,
		max = 80,
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await postReq(
				`/device/generic_command`,
				{
					id,
					command: `tamper_sensitivity`,
					payload: JSON.stringify({ value }),
				},
				10000,
			);
			const toastTexts = {
				success: $format('motion_tamper_scc_toast', {
					values: { value },
					default: `Tamper alarm threshold set to ${value}.`,
				}),
				danger: $format('motion_tamper_err_toast', {
					default: 'Failed to set tamper alarm threshold.',
				}),
			};
			onSettingsResponse(res, device, toastTexts);
			waitForResponse = false;
		};

	let value = settings.tamper_sensitivity,
		waitForResponse = false;

	const a11yProps = {
		sliderValueText: $format('current_sensitivity_value', {
			values: { value },
			default: `Current sensitivity value is ${value}`,
		}),
		ariaLabel: $format('label_set_tamper_sensitivity', { default: 'Set Tamper Sensitivity' }),
		ariaLabelValue: $format('current_sensitivity_value', {
			values: { value },
			default: `Current sensitivity value is ${value}`,
		}),
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('motion_tamper_description', {
		values: { min, max },
		default: `Tamper alarm threshold (from ${min} to ${max}).`,
	})}</Text
>

<Slider id="slider-2yr182z" class="mb-s" type="horizontal" bind:value {min} {max} unit="" {a11yProps} />

<Button size="m" width="full" loading={waitForResponse} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
